
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/option/voip/change",
      function () {
        return require("private-next-pages/option/voip/change/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/option/voip/change"])
      });
    }
  